import { logTransaction } from '../../common/log';
import { LogType } from '../../models/log.model';
import { ConfigName, deleteConfig } from '../common/config';
import { sqlConnectionProvider } from '../sqlConnectionProvider';

// This upgrade reverses version0001 and most of the data out of the native key/value storage
// and back into the SQLite database.

const upgrade = async () => {
  logTransaction(LogType.Internal, '[SQLITE]: Upgrading version 0004');
  const versionString = await sqlConnectionProvider.storageGet(ConfigName.Version);
  const version = parseInt(versionString || '0');
  if (version <= 3) {
    await sqlConnectionProvider.storageSet(ConfigName.Version, '4');
    // Model has changed, must remove all vehicle and attachment data
    await deleteConfig(`${ConfigName.SelectedWorkshopVehicle}`);
    await deleteConfig(`${ConfigName.SelectedStockUnit}`);
    await deleteConfig(`${ConfigName.VehicleAttachmentRequestQueue}`);
    await deleteConfig(`${ConfigName.SelectedVehicleAttachments}`);
    await deleteConfig(`${ConfigName.AdhocAttachmentsCache}`);
    await deleteConfig(`${ConfigName.AdhocVehicleAttachmentsCache}`);
  } else {
    logTransaction(LogType.Internal, '[SQLITE]: Upgrading version 0004 not required');
  }
};

export default upgrade;
